import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, ButtonDropdown, Checkbox, FormField, Input, Modal, Multiselect, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { format, parse } from 'date-fns';
import ConfirmDelete from '../../../../../components/extras/ConfirmDelete';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemUser } from '../../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';

export const SystemUsersListPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [stage, setStage] = useState("A")
    const [users, setUsers] = useState<ItemUser[]>([]);
    const [usersGroups, setUsersGroups] = useState<any[]>([]);
    const [user, setUser] = useState<ItemUser | null>(null);
    const [showDelete, setShowDelete] = useState<boolean>(false);
    const [showModalModifyUser, setShowModalModifyUser] = useState<boolean>(false);
    const { navigate } = useRouter();
    const { data, idUser, idAirport } = useGlobalState();
    const { menu } = useGlobalState();

    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const timer = setTimeout(() => {
            handleGetUsers();
        }, 500);
        return () => clearTimeout(timer);
    }, [idAirport]);
    const handleUserGroups = async () => { // Make the function async
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/system/users/usergroups/list',
                },
                body: JSON.stringify(user),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                console.log(dataWeb.userGroups)
                setUsersGroups(dataWeb.userGroups.map((ug: any) => ({
                    idGroup: ug.idGroup,
                    groupName: ug.groupName,
                    value: ug.idGroup.toString(),
                    label: ug.groupName
                })));
            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            console.log("END")
            setLoading(false)
        }
    }
    const handleModifyUser = async () => { // Make the function async
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/system/users/update',
                },
                body: JSON.stringify(user),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                addNotification(dataWeb.status, 'success', setData);
                setUser(null);
                setShowModalModifyUser(false);
                setUsers(dataWeb.users);
            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            console.log("END")
            setLoading(false)
        }
    }
    const handleDeleteUser = async () => { // Make the function async
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/system/users/delete',
                },
                body: JSON.stringify({
                    idUser: user?.idUser
                }),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                addNotification(dataWeb.status, 'success', setData);
                setUsers(dataWeb.users);
            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            console.log("END")
            setLoading(false)
        }
    };

    const handleGetUsers = async () => { // Make the function async

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/system/users/list',
                },
                body: JSON.stringify({}),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                setUsers(dataWeb.users);
            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            console.log("END")
            setLoading(false)
        }
    };
    useEffect(() => {
        handleGetUsers();
    }, []);


    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Usuarios</Header>
                    <Table
                        columnDefinitions={[
                            {
                                id: 'username',
                                header: 'Usuario',
                                cell: item => item.userName,
                            },
                            {
                                id: 'name',
                                header: 'Nombre',
                                cell: item => item.name,
                            },
                            {
                                id: 'dateCreated',
                                header: 'Creado',
                                cell: item => item.dateCreated === "" ? "No disponible" : <FormField label={format(parse(item.dateCreated, "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy")}>
                                    {format(parse(item.dateCreated, "dd-MM-yyyy HH:mm", new Date()), "HH:mm")}
                                </FormField>,
                            },
                            {
                                id: 'dateLastAccess',
                                header: 'Últ acceso',
                                cell: item => item.dateLastLogin === "" ? "No disponible" : <FormField label={format(parse(item.dateLastLogin, "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy")}>
                                    {format(parse(item.dateLastLogin, "dd-MM-yyyy HH:mm", new Date()), "HH:mm")}
                                </FormField>,
                            },
                            {
                                id: 'actions',
                                header: '',
                                cell: item => (<ButtonDropdown variant={'icon'}
                                    items={[
                                        { text: "Modificar", id: "modify" },
                                        { text: "Eliminar", id: "delete", disabled: idUser === item.idUser, disabledReason: idUser === item.idUser ? "No se puede eliminar asi mismo" : "" },
                                        { text: item.isActiveUser === 1 ? "Desactivar" : "Activar", id: "status", disabled: idUser === item.idUser, disabledReason: idUser === item.idUser ? "No se puede cambiar el estado a si mismo" : "" },
                                    ]}
                                    onItemClick={({ detail }) => {
                                        if (detail.id === "delete") {
                                            setUser(item);
                                            setShowDelete(true);
                                        } else if (detail.id === "modify") {
                                            handleUserGroups();
                                            setUser(item);
                                            setShowModalModifyUser(true);
                                        } else if (detail.id === "status") {
                                            setUser({ ...item, isActiveUser: item.isActiveUser === 1 ? 0 : 1 });
                                            console.log(user);




                                        } else if (detail.id === "modify") {
                                            // Logic to open modal or navigate
                                            console.log("Modificar usuario:", item.userName);
                                        }
                                    }}
                                    expandToViewport
                                />),
                            },
                        ]}
                        items={users || []}
                        variant='borderless'
                    />
                    <Modal visible={showModalModifyUser} onDismiss={() => setShowModalModifyUser(false)}
                        header={`Modificar usuario ${user ? user.name : ''}`}
                        footer={
                            <SpaceBetween direction='horizontal' size='xs'>
                                <Button variant="link" onClick={() => setShowModalModifyUser(false)}>Cerrar</Button>
                                <Button variant="primary" onClick={() => handleModifyUser()}>Modificar</Button>
                            </SpaceBetween>
                        }

                    >
                        <SpaceBetween size="m">
                            <FormField label="Nombre">
                                <Input type="text" value={user ? user.name : ''} onChange={(e) => setUser(user ? { ...user, name: e.detail.value } : null)} />
                            </FormField>
                            <FormField label="Usuario">
                                <Input type="text" value={user ? user.userName : ''} onChange={(e) => setUser(user ? { ...user, userName: e.detail.value } : null)} />
                            </FormField>
                            <FormField label="Email">
                                <Input type="email" value={user ? user.userEmail : ''} onChange={(e) => setUser(user ? { ...user, userEmail: e.detail.value } : null)} />
                            </FormField>
                            <Checkbox checked={user ? user.isActiveUser === 1 : false} onChange={(e) => setUser(user ? { ...user, isActiveUser: e.detail.checked ? 1 : 0 } : null)}>
                                Usuario activo
                            </Checkbox>
                            {usersGroups && usersGroups.length > 0 && (
                                <FormField label="Grupos de usuario">
                                    <Multiselect
                                        options={usersGroups.map(ug => ({
                                            label: ug.groupName,
                                            value: ug.idGroup.toString() // Convert number to string
                                        }))}
                                        selectedOptions={user?.jsonGroups ? user.jsonGroups.map((id: number) => {
                                            // Correct logic: Find the group that matches the specific ID from the current map iteration
                                            const group = usersGroups.find(ug => ug.idGroup === id);
                                            return {
                                                label: group ? group.groupName : '',
                                                value: id.toString()
                                            };
                                        }) : []}
                                        onChange={({ detail }) => {
                                            // Convert back to number if your state/backend expects an array of int
                                            const selectedIds = detail.selectedOptions.map((option: any) =>
                                                parseInt(option.value, 10)
                                            );
                                            console.log(selectedIds)
                                            setUser(user ? { ...user, jsonGroups: selectedIds } : null);
                                        }}
                                        placeholder="Seleccionar grupos de usuario"
                                    />
                                </FormField>
                            )}
                        </SpaceBetween>

                    </Modal>
                    <ConfirmDelete show={showDelete} confirmWord={'eliminar'} header={'Eliminar usuario ' + (user ? user.name : '')} action={'Eliminar'} warning={'Esta acción no es reversible'}
                        onConfirm={() => {
                            handleDeleteUser()
                        }}
                        onDismiss={() =>
                            setShowDelete(false)
                        }
                    />
                </SpaceBetween>
            }
        />
    )
};
